exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\n.google-ads[data-v-5b5aae9c] {\n  width: 90%;\n}\n.nav__btn[data-v-5b5aae9c] {\n  outline: none;\n  border: none;\n  background-color: transparent;\n  color: #f05724;\n}\n.nav__btn i[data-v-5b5aae9c] {\n    font-size: 40px;\n}\n.nav__btn span[data-v-5b5aae9c] {\n    font-size: 20px;\n    line-height: 2;\n    vertical-align: top;\n    padding-left: 10px;\n}\n.chuck[data-v-5b5aae9c] {\n  text-align: center;\n  margin-top: 30px;\n  padding: 0 15px;\n}\n.chuck__img[data-v-5b5aae9c] {\n    height: 70px;\n}\n.chuck__jokes[data-v-5b5aae9c] {\n    font-style: italic;\n    font-size: 36px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5b5aae9c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/SearchDetail.vue
// module id = 61
// module chunks = 0